const INITIAL_STATE = {
  data: null,
  remove: null,
  error: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_FAVOURITE_SUCCESS":
      return { ...state, data: action.payload };

    case "GET_FAVOURITE_FAIL":
      return { ...state, error: action.payload };

    case "REMOVE_FAVOURITE_SUCCESS":
      return { ...state, remove: action.payload };

    case "REMOVE_FAVOURITE_FAIL":
      return { ...state, error: action.payload };

    default:
      return state;
  }
};
